import { render, staticRenderFns } from "./dialogEvent.vue?vue&type=template&id=511de25b&"
import script from "./dialogEvent.vue?vue&type=script&lang=js&"
export * from "./dialogEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports